export default __webpack_public_path__ + "static/media/capital_markets-dk.91c8d0b4.svg";